import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CloneLogonSearchItem } from '../../../../interfaces/clone-logon-search-item.interface';
import { UserAddSearchMessagesHelper } from '../../helpers/user-add-search-messages.helper';

@Component({
  selector: 'pl-step-search',
  templateUrl: './step-search.component.html',
  styleUrls: ['./step-search.component.scss'],
  standalone: false,
})
export class StepSearchComponent implements OnChanges {
  @Input() searchCloneableLogonForm!: FormGroup;
  @Input() inputError = false;
  @Input() isTooManyResultsError = false;
  /** Quando o pai reseta para false, o filho acompanha */
  @Input() searchExecuted = false;
  @Input() errorMessage: { title?: string; description?: string } | undefined;
  @Input() hasError = false;
  @Input() searchResultsLoading = false;
  @Input() searchResults: CloneLogonSearchItem[] = [];
  @Input() selectedLogon: CloneLogonSearchItem | null = null;

  @Output() searchRequested = new EventEmitter<string>();
  @Output() selectionChanged = new EventEmitter<CloneLogonSearchItem>();
  @Output() clearSearchEvent = new EventEmitter<void>();
  @Output() searchCriteriaChanged = new EventEmitter<void>();

  public searchValue = '';
  /** Estado interno — controla qual botão exibir (lupa ou X) */
  public searchSubmitted = false;
  public readonly tooManyResultsInlineMessage =
    UserAddSearchMessagesHelper.TOO_MANY_RESULTS_INLINE_MESSAGE;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchExecuted'] && !changes['searchExecuted'].currentValue) {
      this.searchSubmitted = false;
    }
  }

  public onSearchInput(event: Event): void {
    if ((event as KeyboardEvent).key === 'Enter') {
      return;
    }

    const target = event.target as HTMLInputElement;
    this.searchValue = target?.value ?? '';

    if (this.searchSubmitted) {
      this.searchSubmitted = false;
      this.searchCriteriaChanged.emit();
    }
  }

  public onSearchSubmit(searchText?: string | Event): void {
    let value = this.searchValue;

    if (typeof searchText === 'string') {
      value = searchText;
    } else if (searchText instanceof Event) {
      const target = searchText.target as HTMLInputElement;
      value = target?.value ?? this.searchValue;
    }

    value = value.trim();
    if (!value) {
      return;
    }

    this.searchValue = value;
    this.searchSubmitted = true;
    this.searchRequested.emit(value);
  }

  public onSearchButtonClick(): void {
    this.onSearchSubmit(this.searchValue);
  }

  public onSelectionChanged(event: CloneLogonSearchItem): void {
    this.searchSubmitted = true;
    this.selectionChanged.emit(event);
  }

  public clearSearch(): void {
    this.searchValue = '';
    this.searchSubmitted = false;
    this.clearSearchEvent.emit();
  }

  public isSelected(item: CloneLogonSearchItem): boolean {
    return this.selectedLogon?.logon === item.logon;
  }
}
